import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "dashboard-container" }
const _hoisted_2 = { class: "card mb-5 mb-3" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "stats-cards row mb-5" }
const _hoisted_5 = { class: "col-xl-3 col-md-6 mb-3" }
const _hoisted_6 = { class: "card card-stats bg-gradient-primary hover-elevate-up text-white shadow-sm p-4" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = { class: "fw-bold mb-1" }
const _hoisted_9 = { class: "col-xl-3 col-md-6 mb-3" }
const _hoisted_10 = { class: "card card-stats bg-gradient-success hover-elevate-up text-white shadow-sm p-4" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "fw-bold mb-1" }
const _hoisted_13 = { class: "col-xl-3 col-md-6 mb-3" }
const _hoisted_14 = { class: "card card-stats bg-gradient-warning hover-elevate-up text-white shadow-sm p-4" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { class: "fw-bold mb-1" }
const _hoisted_17 = { class: "col-xl-3 col-md-6 mb-3" }
const _hoisted_18 = { class: "card card-stats bg-gradient-info hover-elevate-up text-white shadow-sm p-4" }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "fw-bold mb-1" }
const _hoisted_21 = { class: "row g-5" }
const _hoisted_22 = { class: "col-xl-12" }
const _hoisted_23 = { class: "card card-xl-stretch hover-elevate-up shadow-sm" }
const _hoisted_24 = { class: "card-body py-3" }
const _hoisted_25 = { class: "table-responsive" }
const _hoisted_26 = { class: "table table-hover table-rounded table-striped border gy-4 gs-5" }
const _hoisted_27 = { class: "fw-bold" }
const _hoisted_28 = { class: "text-success" }
const _hoisted_29 = { class: "text-danger" }
const _hoisted_30 = { class: "fs-6 fw-bold bg-light" }
const _hoisted_31 = { class: "text-success" }
const _hoisted_32 = { class: "text-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_row, { gutter: 10 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 24,
              md: 12,
              lg: 6,
              xl: 6
            }, {
              default: _withCtx(() => [
                _cache[3] || (_cache[3] = _createElementVNode("label", null, "Từ ngày:", -1)),
                _createVNode(_component_el_row, { gutter: 10 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      xs: 24,
                      sm: 24,
                      md: 24,
                      lg: 24,
                      xl: 24
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.search.dTuNgay,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search.dTuNgay) = $event)),
                          placeholder: "Chọn ngày",
                          type: "date",
                          class: "w-100",
                          format: "DD/MM/YYYY",
                          "value-format": "DD/MM/YYYY"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 24,
              md: 12,
              lg: 6,
              xl: 6
            }, {
              default: _withCtx(() => [
                _cache[4] || (_cache[4] = _createElementVNode("label", null, "Đến ngày:", -1)),
                _createVNode(_component_el_row, { gutter: 10 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      xs: 24,
                      sm: 24,
                      md: 24,
                      lg: 24,
                      xl: 24
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.search.dDenNgay,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search.dDenNgay) = $event)),
                          placeholder: "Chọn ngày",
                          type: "date",
                          class: "w-100",
                          format: "DD/MM/YYYY",
                          "value-format": "DD/MM/YYYY"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 24,
              md: 12,
              lg: 6,
              xl: 6
            }, {
              default: _withCtx(() => [
                _cache[5] || (_cache[5] = _createElementVNode("label", null, "Quầy:", -1)),
                _createVNode(_component_el_row, { gutter: 10 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      xs: 24,
                      sm: 24,
                      md: 24,
                      lg: 24,
                      xl: 24
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.search.counterID,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search.counterID) = $event)),
                          placeholder: "Chọn quầy",
                          class: "w-100",
                          clearable: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: 'Tất cả',
                              value: null
                            }),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.booths, (booth) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: booth.nMaQuay,
                                label: booth.cTenQuay,
                                value: booth.nMaQuay
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 24,
              md: 12,
              lg: 6,
              xl: 6,
              class: "d-flex align-items-end"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, {
                  gutter: 10,
                  class: "w-100"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      xs: 12,
                      sm: 12,
                      md: 12,
                      lg: 12,
                      xl: 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          plain: "",
                          type: "primary",
                          title: "Tìm kiếm",
                          class: "w-100",
                          onClick: _ctx.getData
                        }, {
                          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createElementVNode("i", { class: "fa fa-search" }, null, -1),
                            _createTextVNode(" Tìm kiếm", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      xs: 12,
                      sm: 12,
                      md: 12,
                      lg: 12,
                      xl: 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          plain: "",
                          type: "success",
                          title: "Xuất Excel",
                          class: "w-100",
                          onClick: _ctx.exportToExcel
                        }, {
                          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                            _createElementVNode("i", { class: "fa fa-download" }, null, -1),
                            _createTextVNode(" Xuất Excel", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "me-3" }, [
              _createElementVNode("i", { class: "fa fa-users fa-2x" })
            ], -1)),
            _createElementVNode("div", null, [
              _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.getTotalSum('total')), 1),
              _cache[8] || (_cache[8] = _createElementVNode("span", null, "Tổng lượt làm việc", -1))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "me-3" }, [
              _createElementVNode("i", { class: "fa fa-check-circle fa-2x" })
            ], -1)),
            _createElementVNode("div", null, [
              _createElementVNode("h4", _hoisted_12, _toDisplayString(_ctx.getTotalSum('completed')), 1),
              _cache[10] || (_cache[10] = _createElementVNode("span", null, "Hoàn thành", -1))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "me-3" }, [
              _createElementVNode("i", { class: "fa fa-times-circle fa-2x" })
            ], -1)),
            _createElementVNode("div", null, [
              _createElementVNode("h4", _hoisted_16, _toDisplayString(_ctx.getTotalSum('rejected')), 1),
              _cache[12] || (_cache[12] = _createElementVNode("span", null, "Từ chối", -1))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "me-3" }, [
              _createElementVNode("i", { class: "fa fa-smile fa-2x" })
            ], -1)),
            _createElementVNode("div", null, [
              _createElementVNode("h4", _hoisted_20, _toDisplayString(_ctx.getTotalSum('veryHappy') + _ctx.getTotalSum('happy')), 1),
              _cache[14] || (_cache[14] = _createElementVNode("span", null, "Đánh giá tốt", -1))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "card-header border-0 bg-light" }, [
            _createElementVNode("h4", { class: "card-title align-items-start flex-row align-items-center" }, [
              _createElementVNode("span", { class: "card-label fw-bolder fs-4" }, "Thống kê theo ngày làm việc")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("table", _hoisted_26, [
                _cache[17] || (_cache[17] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", { class: "fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200" }, [
                    _createElementVNode("th", null, "Ngày"),
                    _createElementVNode("th", null, "Tổng lượt"),
                    _createElementVNode("th", null, "Hoàn thành"),
                    _createElementVNode("th", null, "Từ chối"),
                    _createElementVNode("th", null, "Rất hài lòng"),
                    _createElementVNode("th", null, "Hài lòng"),
                    _createElementVNode("th", null, "Bình thường"),
                    _createElementVNode("th", null, "Không hài lòng")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.counterStats, (counter) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: counter.id,
                      class: "fs-6"
                    }, [
                      _createElementVNode("td", _hoisted_27, _toDisplayString(counter.name), 1),
                      _createElementVNode("td", null, _toDisplayString(counter.total), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_28, _toDisplayString(counter.completed), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_29, _toDisplayString(counter.rejected), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", null, _toDisplayString(counter.veryHappy), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", null, _toDisplayString(counter.happy), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", null, _toDisplayString(counter.neutral), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", null, _toDisplayString(counter.unhappy), 1)
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("tr", _hoisted_30, [
                    _cache[16] || (_cache[16] = _createElementVNode("td", null, "Tổng hợp", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.getTotalSum('total')), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.getTotalSum('completed')), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.getTotalSum('rejected')), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.getTotalSum('veryHappy')), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.getTotalSum('happy')), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.getTotalSum('neutral')), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.getTotalSum('unhappy')), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}